import {createStore} from 'jotai'

const jotaiStore: any = createStore()

export default jotaiStore
